import { render } from "./PCInformacionCabecera.vue?vue&type=template&id=f01d15aa&scoped=true"
import script from "./PCInformacionCabecera.vue?vue&type=script&lang=js"
export * from "./PCInformacionCabecera.vue?vue&type=script&lang=js"

import "./PCInformacionCabecera.vue?vue&type=style&index=0&id=f01d15aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f01d15aa"]])

export default __exports__